export const defaultQueryProps = {
  limit: 12,
  offset: 0,
}
